import { createAction, props } from '@ngrx/store';
import { IVisorState } from 'app/visor/shared/models/mapModels';
const RESTORE_STATE = '[LEAFLET] Restore visor state';
export const restoreVisorState = createAction(RESTORE_STATE, props<{ visor: IVisorState }>());
